export default {
  PROFILE_SHOW: 'profile:show',

  // LEAVE
  LEAVE_ADD_SUCCESS: 'leave:add-success',
  LEAVE_ADD_ERROR: 'leave:add-error',
  LEAVE_CANCEL_SUCCESS: 'leave:cancel-success',
  LEAVE_CANCEL_ERROR: 'leave:cancel-error',
};
